<template lang="html">
  <header class="section-heading">
    <div>
      <span class="notch notch--dark notch--lg notch--bm"></span>
      <h2>{{ heading }}</h2>
      <p v-if="body">{{ body }}</p>
    </div>
  </header>
</template>

<script>
  export default {
    components: {
    },
    name: 'section-intro',
    props: {
      heading: String,
      body: String
    },
    data () {
      return {
      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .section-heading {
    padding: 7.500rem 1rem 5rem 1rem;
    > div {
      margin: 0 auto;
      max-width: 61.250rem;
      text-align: center;
      h2 {
        margin: 0;
        font-family: $montserrat;
        font-size: 2.750rem;
        font-weight: 700;
        color: $light-red;
        text-transform: uppercase;
      }
      p {
        text-align: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SectionIntro.vue